import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CompetitionView from './CompetitionView'
import PlayerView from './PlayerView'
import TeamView from './TeamView'

const CompetitionsApp = () => {
  return (
    <Switch>
      <Route path="/soccer/competition/:competitionId/team/:teamId/player/:playerId">
        <PlayerView/>
      </Route>
      <Route path="/soccer/competition/:competitionId/team/:teamId">
        <TeamView/>
      </Route>
      <Route exact path="/soccer/competition/:competitionId">
        <CompetitionView/>
      </Route>
    </Switch>
  )
}

export default CompetitionsApp